import { axios } from "../config";

function getDepartments(schoolId) {
  return axios.get(`api/auth/login/${schoolId}`);
}

export { getDepartments };
